module.exports = __webpack_public_path__ + "img/link.cfe8398a.svg";